<script setup lang="ts">
    import ElementInput from '@/components/ElementInput.vue';
    import TextEditForm from '@/components/TextEditForm.vue';
    import useConfigStore from '@/store/config.store';
    import useField from '@/composables/useField';
    import { storeToRefs } from 'pinia';
    import type { ITextField } from '@/typescript/interfaces/ITextField';

    const { field } = defineProps<{
        field: ITextField;
    }>();

    const { isFormVisible, showForm, deleteField, toggleLock, hideForm, duplicateField } = useField(field.id);

    const { isAdmin } = storeToRefs(useConfigStore());
</script>
<template>
    <ElementInput
        :model-value="field.text"
        deletable
        :lockable="isAdmin"
        as-button
        editable
        :locked="!field.editable"
        :placeholder="field.defaultText"
        :duplicable="!!field.text"
        :delete-title="$t('deleteText')"
        :edit-title="$t('editText')"
        :duplicate-title="$t('duplicateText')"
        @click="showForm"
        @edit="showForm"
        @delete="deleteField(field)"
        @lock="toggleLock(field)"
        @duplicate="duplicateField(field)"
    >
        <template #thumbnail>
            <span class="sr-only">{{ $t('document_icon') }}</span>
            <span
                class="flex h-6 w-6 flex-row items-center justify-center font-serif text-2xl text-text"
                :title="$t('text')"
                >T</span
            >
        </template>
    </ElementInput>
    <Teleport
        v-if="isFormVisible"
        to="#formContainer"
    >
        <TextEditForm
            class="pointer-events-auto"
            :field
            @close="hideForm"
        />
    </Teleport>
</template>
